/** Null means no role restriction; an empty snapshot deliberately matches nobody. */
export function filterGuildPlayers<T extends { readonly discordUserId?: string | null }>(
  players: ReadonlyArray<T>,
  eligibleDiscordIds: ReadonlyArray<string> | null,
): ReadonlyArray<T> {
  if (eligibleDiscordIds === null) return players
  const eligible = new Set(eligibleDiscordIds)
  return players.filter((player) => eligible.has(player.discordUserId ?? ''))
}

/** Reorder visible slots without deleting the hidden players from saved groups. */
export function mergeVisiblePlayerOrder(
  fullOrder: ReadonlyArray<string>,
  visibleOrder: ReadonlyArray<string>,
  visibleIds: ReadonlySet<string>,
): ReadonlyArray<string> {
  let next = 0
  const merged = fullOrder.flatMap((id) => {
    if (!visibleIds.has(id)) return [id]
    const replacement = visibleOrder[next++]
    return replacement === undefined ? [] : [replacement]
  })
  return [...merged, ...visibleOrder.slice(next)]
}

/** Sortable reports a visible index; mutations operate on the complete group. */
export function fullPlayerInsertIndex(
  fullOrder: ReadonlyArray<string>,
  visibleIds: ReadonlySet<string>,
  movingId: string,
  visibleIndex: number,
): number {
  const destination = fullOrder.filter((id) => id !== movingId)
  let visibleBefore = 0
  for (let index = 0; index < destination.length; index += 1) {
    if (!visibleIds.has(destination[index] ?? '')) continue
    if (visibleBefore === visibleIndex) return index
    visibleBefore += 1
  }
  return destination.length
}
